module.exports = __webpack_public_path__ + "img/kp.4c4b2940.svg";